import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/css/css.js";

function showHide(controls, values) {
	let show = true;
	const localvalues = Object.assign({}, values); // make a clone so we can track which ones we have checked
	controls.each(function () {
		const name = this.name,
			value = $(this).val(),
			type = this.type;
		if (!(name in values)) {
			return; // ignore controls that aren't part of this condition set (used when OR-ing multiple sets)
		}
		if (!["checkbox", "radio"].includes(type) || this.checked) {
			const compare = localvalues[name];
			delete localvalues[name];
			if (compare !== value) {
				show = false;
				return false;
			}
		}
	});
	return Object.keys(localvalues).length ? false : show;
}

export default obj => {
	obj.each(function () {
		const $this = $(this),
			form = $("input,textarea,select", this).get(0).form,
			data = $this.data("show"),
			// an object is a single condition set (AND); an array is a list of sets, any of which showing the control (OR)
			sets = Array.isArray(data) ? data : [data],
			names = sets.reduce((all, set) => {
				Object.keys(set).forEach(name => all.includes(name) || all.push(name));
				return all;
			}, []),
			controls = $(names.reduce((value, item) => (value ? value + "," : "") + "[name=" + item + "]", ""), form),
			update = () => {
				const show = sets.some(set => showHide(controls, set));
				$this.css("display", show ? "block" : "none");
			};
		controls.on("input", update);
		update();
	});
};